import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IpAddressService {

  constructor(private http: HttpClient) { }

  getIPAddress(): Observable<string> {
    const apiUrl = 'https://api.ipify.org/?format=json';

    return this.http.get<any>(apiUrl).pipe(
      map((response: any) => {
        return response.ip;
      })
    );
  }
}
